import React from "react";
import { Text } from "../../../components";

export const chaveiro = {
  title: "Chaveiro",
  body: (
    <>
      <Text>
        Se a porta for arrombada, a casa for assaltada ou simplesmente você
        perder as chaves, a gente manda alguém até você.
      </Text>
    </>
  ),
};

export const conexaoTelefonica = {
  title: "Conexão Telefônica",
  body: (
    <>
      <Text>
        Pelo telefone, você obtém indicações de prestadores de serviço e
        informações sobre o trânsito, clima, programação cultural e muito mais.
      </Text>
    </>
  ),
};

export const encanador = {
  title: "Encanador",
  body: (
    <>
      <Text>
        Conte com serviços de hidráulica em casos de emergência ou sinistro para
        reparar vazamento interno que cause ou possa causar um alagamento.
        Lembrando que a assistência será realizada apenas em caso de vazamentos
        aparentes.
      </Text>
    </>
  ),
};

export const servicosSegurancaVigilancia = {
  title: "Serviços e Segurança e Vigilância",
  body: (
    <Text>
      Você tem direito a até 36 horas de serviço de vigilante em seu imóvel,
      caso ele fique vulnerável, em caso de algum dano ou prejuízo coberto pelo
      seu seguro.
    </Text>
  ),
};

export const vidraceiro = {
  title: "Vidraceiro",
  body: (
    <Text>
      Em caso de emergência, enviamos vidraceiro para consertar portas de vidro
      ou janelas externas de vidro. Caso não seja possível a execução do serviço
      será colocado um tapume. Lembrando que essa assistência não inclui vidros
      de blindex, apenas vidros simples.
    </Text>
  ),
};

export const coberturaProvisoriaTelhados = {
  title: "Cobertura Provisória de Telhados",
  body: (
    <>
      <Text>
        Em caso de emergência, enviamos um profissional para realizar a
        cobertura provisória do telhado com lona ou plástico.
      </Text>
    </>
  ),
};

export const eletricista = {
  title: "Eletricista",
  body: (
    <>
      <Text>
        A gente envia eletricista para reparar o que for necessário para
        reestabelecer a energia elétrica ou solucionar problemas elétricos,
        dependendo do evento ocorrido.
      </Text>
    </>
  ),
};

export const limpezaDoImovel = {
  title: "Limpeza do Imóvel",
  body: (
    <>
      <Text>
        Enviaremos profissionais de limpeza ao seu imóvel, caso fique inabitável
        em consequência de eventos cobertos pelo seu seguro. Nessas situações, o
        objetivo será recuperar superficialmente os danos para possibilitar a
        entrada dos moradores ou ao menos minimizar efeitos do sinistro,
        preparando o imóvel para um reparo posterior definitivo.
      </Text>
    </>
  ),
};

export const transporteArmazenamentoDeMoveis = {
  title: "Transporte e Armazenamento de Móveis",
  body: (
    <>
      <Text>
        Caso você precise desocupar seu imóvel em consequência de algum evento
        coberto pelo seu seguro, retiramos os móveis e transportamos para você.
      </Text>
    </>
  ),
};

export const cestaBasica = {
  title: "Cesta Básica",
  body: (
    <>
      <Text>
        Em caso de morte natural ou acidental, disponibilizamos uma cesta básica
        no valor de R$ 150,00 durante 6 meses.
      </Text>
    </>
  ),
};

export const servicoAssistenciaFuneral = {
  title: "Serviço de asistência funeral (SAF)",
  body: (
    <>
      <Text>
        Em caso de morte natural ou acidental, nós faremos a realização do
        funeral do segurado.
      </Text>
    </>
  ),
};
